import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import es from "./locales/es.json";
import en from "./locales/en.json";
import ro from "./locales/ro.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
      ro: { translation: ro },
    },
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "afrodise-lang",
      // if browser lang is es or ro, use it — otherwise default to en
      convertDetectedLanguage: (lng) => {
        if (lng.startsWith("es")) return "es";
        if (lng.startsWith("ro")) return "ro";
        return "en";
      },
    },
  });

export default i18n;
